import { motion } from 'framer-motion'

interface Props {
  totalPages: number
  currentPage: number
  durationMs: number
}

export function StoryProgressBars({ totalPages, currentPage, durationMs }: Props) {
  return (
    <div className="absolute left-6 right-6 top-3 z-10 flex gap-1.5">
      {Array.from({ length: totalPages }).map((_, i) => (
        <div
          key={i}
          className="h-1 flex-1 overflow-hidden rounded-full bg-white/15"
          aria-hidden="true"
        >
          {i < currentPage && <span className="block h-full w-full bg-white/85" />}
          {i === currentPage && (
            <motion.span
              key={`active-${currentPage}`}
              className="block h-full bg-white"
              initial={{ width: '0%' }}
              animate={{ width: '100%' }}
              transition={{ duration: durationMs / 1000, ease: 'linear' }}
            />
          )}
        </div>
      ))}
    </div>
  )
}
